// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".normal-btn{fill:#e5e5e5}.normal-btn:hover{fill:#494949}.highlight-btn{fill:#494949}\n", ""]);
